import { getCurrentInstance, SetupContext, computed } from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';
import { FeedLiked, Feed } from '@/api/feed';
import { FeedPageEnum } from '@/store/modules/feed';
import { ActionType, ActionBarProps } from './common';

export const ActionBarAppSetup = (props: ActionBarProps, ctx: SetupContext<Array<'onChangeLoginPopupVisible'>>) => {
    // const baseSetup = ActionBarBaseSetup(props, ctx);
    const { proxy } = getCurrentInstance() || {};
    // const { feedList } = baseSetup || {};

    const feedList = computed<Feed[]>(() => {
        const { feedListOrigin } = proxy?.$store?.state?.feedMoudle || {};
        return feedListOrigin?.[props?.feedPage || FeedPageEnum.PwaShareNew] || [];
    });

    const handleLikeAction = debounce(async (type: ActionType) => {
        const feedLikeStatus = type === ActionType.Like ? FeedLiked.Like : FeedLiked.UnLike;

        const newFeedList = feedList.value?.map?.(feed => {
            if (feed.photo_id_str === props?.photoId) {
                return {
                    ...feed,
                    liked: feedLikeStatus,
                };
            }
            return feed;
        });
        proxy?.$store?.commit?.('feedMoudle/resetFeedList', props.feedPage);
        proxy?.$store?.commit?.('feedMoudle/setFeedList', {
            [props?.feedPage || FeedPageEnum.PwaShareNew]: newFeedList || [],
        });
    }, 300);

    return {
        handleLikeAction,
    };
};
